<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogDetail"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Detail de la demande</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 class="text-xs-right">
              <v-btn
                icons
                dark
                color="orange"
                @click="imprimerDemande(intervDetail.id)"
                >imprimer<v-icon right>print</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-card color="" class="mb-5" flat>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-alert :value="true" outline color="purple" icon="info">
                      Informations generales sur la demande
                    </v-alert>
                    <v-card flat>
                      <v-layout wrap>
                        <v-card-text>
                          <v-flex xs12>
                            <v-flex xs12 class="text-xs-left">
                              <!--HAUT-->
                              <v-layout row>
                                <v-flex xs6 class="mr-4">
                                  <!--COLONNE 1-->
                                  <v-layout row>
                                    <v-flex xs6
                                      >Reference de l'intervention</v-flex
                                    >
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.ref }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Vehicule </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.vehicule }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Chauffeur du véhicule </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.conducteur }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Montant Total (Fcfa) </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{
                                        new Intl.NumberFormat().format(
                                          intervDetail.mntTotal
                                        )
                                      }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Date demande </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.dateFormat2 }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Type</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.type }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Gravite</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.gravite }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row v-if="intervDetail.etat == 2">
                                    <v-flex xs2>Motif de refus</v-flex>
                                    <v-flex xs10>
                                      <el-form class="demo-ruleForm">
                                        <el-form-item
                                          label=""
                                          style="width:100%"
                                        >
                                          <el-input
                                            :readonly="true"
                                            type="textarea"
                                            v-model="
                                              intervDetail.remarqueValider
                                            "
                                          ></el-input>
                                        </el-form-item>
                                      </el-form>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout row>
                                    <v-flex xs3 class="mr-3">
                                      <a
                                        :href="intervDetail.photoDevis"
                                        target="_blank"
                                      >
                                        <v-avatar
                                          :tile="true"
                                          size="140px"
                                          height="120px"
                                          color="grey lighten-4"
                                        >
                                          <img :src="intervDetail.photoDevis"
                                        /></v-avatar>
                                      </a>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs6 class="text-xs-left">
                                  <!--BAS-->
                                  <v-layout row>
                                    <v-flex xs6>Categorie</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.categorie }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Priorite</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.priorite }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row>
                                    <v-flex xs6>Enregistré par </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.demandeur }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row v-if="intervDetail.kilometrage">
                                    <v-flex xs6>Kilometrage </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.kilometrage }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    class="mb-3"
                                    v-if="intervDetail.kilometrage"
                                  ></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Etat</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.libEtat }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>

                                  <v-layout row v-if="intervDetail.caisse">
                                    <v-flex xs6>Caisse </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.caisse }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider
                                    class="mb-3"
                                    v-if="intervDetail.caisse"
                                  ></v-divider>

                                  <v-layout
                                    row
                                    v-if="intervDetail.datePaiementFormat"
                                  >
                                    <v-flex xs6>Date de paiement </v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      {{ intervDetail.datePaiementFormat }}
                                    </v-flex>
                                  </v-layout>

                                  <v-layout row>
                                    <v-flex xs2>Description</v-flex>
                                    <v-flex xs10>
                                      <el-form class="demo-ruleForm">
                                        <el-form-item
                                          label=""
                                          style="width:100%"
                                        >
                                          <el-input
                                            :readonly="true"
                                            type="textarea"
                                            v-model="intervDetail.motif"
                                          ></el-input>
                                        </el-form-item>
                                      </el-form>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>
                        </v-card-text>
                      </v-layout>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 v-if="intervDetail.diagnostiqueId">
                    <v-flex xs12>
                      <v-alert :value="true" outline color="purple" icon="info">
                        Diagnostique
                      </v-alert>
                    </v-flex>
                    <v-layout>
                      <v-flex xs6 class="text-xs-left mb-3">
                        <!--BAS-->
                        <v-layout row>
                          <v-flex xs6>Reference Diagnostique</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            Ref-DIAG-{{ intervDetail.diagnostiqueId }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                        <v-layout row>
                          <v-flex xs6>Diagnostique</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ intervDetail.libelleDiag }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                        <v-layout row>
                          <v-flex xs6>Date d'enregistrement </v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ intervDetail.dateDiagEnreg }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs3 class="mr-3">
                            <a :href="intervDetail.imageDmd" target="_blank">
                              <v-avatar
                                :tile="true"
                                size="140px"
                                height="120px"
                                color="grey lighten-4"
                              >
                                <img :src="intervDetail.imageDmd"
                              /></v-avatar>
                            </a>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs6 class="text-xs-left ml-4">
                        <v-layout row v-if="intervDetail.maindoeuvre">
                          <v-flex xs6>Main d'oeuvre (Fcfa)</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ intervDetail.maindoeuvre }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                        <v-layout row>
                          <v-flex xs6>Diagnostique enregistré par</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ intervDetail.userDiag }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>

                        <v-layout row>
                          <v-flex xs6>Entrepot concerné</v-flex>
                          <v-flex xs6 class="text-xs-right title">
                            {{ intervDetail.entrepot }}
                          </v-flex>
                        </v-layout>
                        <v-divider class="mb-3"></v-divider>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12>
                        <v-card class="pt-3 pl-2">
                          <h3>LISTE DES ARTICLES EN STOCK</h3>
                          <v-flex xs12>
                            <v-chip
                              style="font-size:20px"
                              label
                              outline
                              color="green"
                              ><b
                                >Total (TTC):
                                {{ intervDetail.mntArtStock }} fcfa</b
                              ></v-chip
                            >
                          </v-flex>

                          <v-layout row>
                            <el-table
                              :data="intervDetail.articleStock"
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="libelle"
                                label="Designation"
                                sortable
                              >
                              </el-table-column>
                              <el-table-column prop="qte" label="Quantite">
                              </el-table-column>
                              <el-table-column
                                prop="cout"
                                label="Prix unitaire"
                              ></el-table-column>
                              <el-table-column
                                prop="tva"
                                label="Tva"
                              ></el-table-column>
                              <el-table-column
                                prop="unite"
                                label="Unite"
                              ></el-table-column>
                              <el-table-column
                                prop="total"
                                label="Total"
                              ></el-table-column>
                            </el-table>
                          </v-layout>
                          <br />
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 v-if="intervDetail.etat > 0" class="mt-4">
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-card class="pt-3 pl-2">
                          <h3>LISTE DES ARTICLES FOURNIS PAR LE GARAGE</h3>
                          <v-flex xs12>
                            <v-chip
                              style="font-size:20px"
                              label
                              outline
                              color="green"
                              ><b
                                >Total (TTC):
                                {{ intervDetail.mntArtGarage }} fcfa</b
                              ></v-chip
                            >
                          </v-flex>

                          <v-layout row>
                            <el-table
                              :data="intervDetail.devis"
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="libelle"
                                label="Designation"
                                sortable
                              >
                              </el-table-column>
                              <el-table-column prop="qte" label="Quantite">
                              </el-table-column>
                              <el-table-column
                                prop="cout"
                                label="Prix unitaire"
                              ></el-table-column>
                              <el-table-column
                                prop="tva"
                                label="Tva"
                              ></el-table-column>
                              <el-table-column
                                prop="unite"
                                label="Unite"
                              ></el-table-column>
                              <el-table-column
                                prop="total"
                                label="Total"
                              ></el-table-column>
                            </el-table>
                          </v-layout>
                          <br />
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 v-if="intervDetail.etat >= 5">
                    <v-alert :value="true" outline color="purple" icon="info">
                      Planification de l'intervention
                    </v-alert>
                    <v-card color="" class="mb-5">
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs6 class="mr-4">
                            <!--COLONNE 1-->
                            <v-layout row>
                              <v-flex xs6
                                >Date de debut de l'intervention</v-flex
                              >
                              <v-flex xs6 class="text-xs-right title">
                                {{ intervDetail.dateDFormat2 }}
                              </v-flex>
                            </v-layout>
                            <v-divider class="mb-3"></v-divider>

                            <v-layout row>
                              <v-flex xs6>Date de fin de l'intervention</v-flex>
                              <v-flex xs6 class="text-xs-right title">
                                {{ intervDetail.dateFFormat2 }}
                              </v-flex>
                            </v-layout>
                            <v-divider class="mb-3"></v-divider>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 v-if="intervDetail.etat == 5">
                    <v-alert :value="true" outline color="purple" icon="info">
                      Rapport de depannage
                    </v-alert>
                    <v-card color="" class="mb-5">
                      <v-card-text>
                        <v-layout wrap>
                          <v-flex xs6 class="mr-4">
                            <!--COLONNE 1-->

                            <v-layout row>
                              <v-flex xs8>
                                <v-layout row>
                                  <v-flex
                                    v-if="intervDetail.url"
                                    xs3
                                    class="mr-3"
                                  >
                                    <a :href="intervDetail.url" target="_blank">
                                      <v-avatar
                                        :tile="true"
                                        size="140px"
                                        height="120px"
                                        color="grey lighten-4"
                                      >
                                        <img :src="intervDetail.url"
                                      /></v-avatar>
                                    </a>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex xs4>Remarque</v-flex>
                                  <v-flex xs10>
                                    <el-form class="demo-ruleForm">
                                      <el-form-item label="" style="width:100%">
                                        <el-input
                                          :readonly="true"
                                          type="textarea"
                                          v-model="intervDetail.remarqueFin"
                                        ></el-input>
                                      </el-form-item>
                                    </el-form>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider class="mb-3"></v-divider>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "DetailIntervention",
  props: ["show", "intervDetail"],
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      tableProduit: [],
      totalTTC: 0,
      formRapport: {},
      dialogVisible: false,
      dialogImageUrl: "",
      imageDmd1: ""
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    imprimerDemande(idInterv) {
      let url =
        this.domaine + "intervention/" + idInterv + "/imprimer/" + this.user.id;

      window.open(url);
    },

    closeDialog() {
      this.$emit("close");
    },

    handleRemove(file, fileList) {
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push(file);
    },
    handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;

      this.dialogVisible = true;
    },
    imprimerDetail() {
      let url =
        this.domaine +
        "demande_maintenance/imprimerPDF/demande/" +
        this.user.id +
        "/" +
        this.demandeDetail.idDemande;
      window.open(url);
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/intervention/DetailIntervention.vue